var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"-dialog-footer"},[_vm._t("left",function(){return [_c('div',{directives:[{name:"tab-guard",rawName:"v-tab-guard"}],staticClass:"-buttons-box"},[_vm._t("buttons")],2)]}),_vm._v(" "),_vm._t("right")],2)}
var staticRenderFns = []

export { render, staticRenderFns }